/*
 * Copyright (c) 2016 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
import { Directive, HostListener } from "@angular/core";
import { IfOpenService } from "./if-open.service";
/*********
 *
 * @class SignpostTriggerDirective
 *
 * @Description
 * A Directive added to the Signpost Trigger button that will call the Signpost.toggle() function to hide/show the
 * SignpostContent.
 *
 */
var SignpostTriggerDirective = (function () {
    function SignpostTriggerDirective(ifOpenService) {
        this.ifOpenService = ifOpenService;
    }
    /**********
     * @function onSignpostContentClick
     *
     * @description
     * click handler for the Signpost trigger button used to hide/show SignpostContent.
     */
    SignpostTriggerDirective.prototype.onSignpostTriggerClick = function () {
        this.ifOpenService.open = !this.ifOpenService.open;
    };
    return SignpostTriggerDirective;
}());
export { SignpostTriggerDirective };
SignpostTriggerDirective.decorators = [
    { type: Directive, args: [{
                selector: "[clrSignpostTrigger]"
            },] },
];
/** @nocollapse */
SignpostTriggerDirective.ctorParameters = function () { return [
    { type: IfOpenService, },
]; };
SignpostTriggerDirective.propDecorators = {
    'onSignpostTriggerClick': [{ type: HostListener, args: ["click",] },],
};
//# sourceMappingURL=signpost-trigger.directive.js.map


//////////////////
// WEBPACK FOOTER
// ./~/clarity-angular/popover/signpost/signpost-trigger.directive.js
// module id = 206
// module chunks = 4